exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".countdown{font-size:4em;text-align:center}.vc-slider{width:100%}.message-del{margin-left:10px}.color-modal{width:280px !important}.row .col.s05{width:5%;margin-left:auto;left:auto;right:auto}.row .col.s115{width:95%;margin-left:auto;left:auto;right:auto}\n", ""]);

